<template>
  <div class="blog-view-container">
    <BlogCard v-for="(article, ai) in articles" :key="ai" :article="article" />
  </div>
</template>

<script>
import articles from '../blog/index'
import BlogCard from '../blog/BlogCard'

export default {
  components: {
    BlogCard
  },
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      articles
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.blog-view-container {
  padding: var(--gap-size) 0;
}
</style>



// WEBPACK FOOTER //
// src/components/BlogView.vue